/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="77.99"
        height="95.58"
        viewBox="0 0 77.99 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.99 16.79A25.09 25.09 0 0 0 13.9 41.88c0 5.82 1.65 10.79 5.22 17.74l2.13 4.1.86 1.69.6 1.2.41.84.34.74.29.66.13.31.11.29.1.27.09.26.12.37.07.24.06.23v6.32a1.25 1.25 0 0 0 1.42 1.24l25.84-3.69a1.25 1.25 0 0 0 1.08-1.24v-2.14l.07-.33.06-.23.07-.24.08-.25.15-.39.16-.43.13-.3.22-.49.24-.53.39-.8.45-.89.52-1L56.59 63l1.4-2.63c3.89-7.28 5.69-12.41 5.69-18.44a25.09 25.09 0 0 0-24.69-25.14Zm0 2.5a22.59 22.59 0 0 1 22.59 22.59c0 5.37-1.59 10.06-5.09 16.7l-1.14 2.12-1.19 2.2-.44.82-.39.76c-.06.12-.13.24-.18.35l-.34.69c-.06.11-.11.22-.16.33l-.3.64-.2.44a18.78 18.78 0 0 0-1.55 5.08v.31l-23.39 3.34v-2.37a17.07 17.07 0 0 0-1.8-6.91l-.14-.32-.3-.65-.33-.68-.36-.73-.85-1.64-1.75-3.31c-3.61-6.94-5.24-11.69-5.24-17.17a22.59 22.59 0 0 1 22.55-22.59ZM51.08 77.6a1.25 1.25 0 0 1 .5 2.45h-.13l-23.6 3.58a1.25 1.25 0 0 1-.5-2.45h.13ZM51.08 82.37a1.25 1.25 0 0 1 .5 2.44h-.13l-23.6 3.57a1.24 1.24 0 0 1-1.42-1 1.25 1.25 0 0 1 .92-1.4h.13ZM48.17 89.5a1.25 1.25 0 0 1 1.25 1.25c0 3-4.57 4.83-10.07 4.83s-10.07-1.85-10.07-4.83a1.25 1.25 0 0 1 2.5 0c0 .32.58.88 1.8 1.38a18 18 0 0 0 11.53 0c1.23-.5 1.81-1.06 1.81-1.38a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M30.36 47.6a1 1 0 0 1 1.78-.63 12.53 12.53 0 0 1 1.54 2.75l.15.35h.07a2.73 2.73 0 0 0 1.1.3h.18a2.81 2.81 0 0 0 2.81-2.82 1 1 0 0 1 2 0 2.82 2.82 0 0 0 4.86 1.95h.05l.07-.24.16-.47.17-.5a2.09 2.09 0 0 0 .08-.23l.2-.53.12-.3a1 1 0 0 1 1.92.39 4.81 4.81 0 0 1-.84 2.72l-.09.12-.11.38c-.2.66-.39 1.37-.58 2.12l-.15.58a63.58 63.58 0 0 0-1.71 14.74 1 1 0 0 1-2 0 65.32 65.32 0 0 1 1.77-15.21l.15-.6v-.21H44a4.34 4.34 0 0 1-1 .16h-.21a4.82 4.82 0 0 1-3.74-1.78l-.08-.1-.08.1a4.8 4.8 0 0 1-3.52 1.77h-.72l.12.38a52.93 52.93 0 0 1 2 14.79v.7a1 1 0 0 1-2 0 49.66 49.66 0 0 0-2.16-15.78c-.1-.3-.2-.6-.31-.88l-.11-.27a4.85 4.85 0 0 1-1.78-3.52ZM38.99 3.98a1.24 1.24 0 0 1 1.24 1.12v4.47a1.25 1.25 0 0 1-2.49.13V5.23a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M38.99 0a1.24 1.24 0 0 1 1.24 1.12v8.45a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 38.99 0ZM14.63 7.81a1.26 1.26 0 0 1 1.66.17l.08.11 4.9 6.74a1.25 1.25 0 0 1-1.94 1.57l-.08-.1-4.9-6.74a1.26 1.26 0 0 1 .28-1.75ZM.06 26.5a1.25 1.25 0 0 1 1.44-.83h.12l7.95 2.54a1.252 1.252 0 0 1-.64 2.42h-.12l-8-2.54a1.25 1.25 0 0 1-.75-1.59Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M38.99 3.98a1.24 1.24 0 0 1 1.24 1.12v4.47a1.25 1.25 0 0 1-2.49.13V5.23a1.25 1.25 0 0 1 1.25-1.25ZM61.61 8.09a1.25 1.25 0 0 1 2.09 1.35l-.07.12-4.9 6.73a1.25 1.25 0 0 1-2.09-1.35l.07-.12ZM76.36 25.7a1.25 1.25 0 0 1 .88 2.33h-.12l-8 2.54a1.25 1.25 0 0 1-.88-2.33h.12Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'LightbulbIcon';

export default Icon;
